var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 57.143,
    viewBox: "0 0 50 57.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37525",
    "data-name": "Group 37525",
    transform: "translate(-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35314",
    "data-name": "Path 35314",
    d: "M99.571,0A3.582,3.582,0,0,0,96,3.571v50a3.582,3.582,0,0,0,3.571,3.571h35.714a3.582,3.582,0,0,0,3.571-3.571V14.286L124.571,0Z",
    transform: "translate(-56.857)",
    fill: "#e2e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35315",
    "data-name": "Path 35315",
    d: "M355.571,14.286h10.714L352,0V10.714A3.582,3.582,0,0,0,355.571,14.286Z",
    transform: "translate(-284.286)",
    fill: "#b0b7bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35316",
    "data-name": "Path 35316",
    d: "M394.714,138.714,384,128h10.714Z",
    transform: "translate(-312.714 -113.714)",
    fill: "#cad1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35317",
    "data-name": "Path 35317",
    d: "M74.857,259.643a1.791,1.791,0,0,1-1.786,1.786H33.786A1.791,1.791,0,0,1,32,259.643V241.786A1.791,1.791,0,0,1,33.786,240H73.071a1.791,1.791,0,0,1,1.786,1.786Z",
    transform: "translate(0 -213.214)",
    fill: "#84bd5a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37524",
    "data-name": "Group 37524",
    transform: "translate(40.173 32.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35318",
    "data-name": "Path 35318",
    d: "M109.591,298.52l2.484-3.112c.743-.971,2.186.27,1.371,1.2-.855,1.014-1.755,2.114-2.612,3.241l2.912,3.627a.937.937,0,1,1-1.555,1.041l-2.629-3.37-2.584,3.443c-.729,1.041-2.343-.129-1.529-1.1l2.87-3.641c-.9-1.129-1.771-2.227-2.641-3.241a.924.924,0,1,1,1.429-1.168Z",
    transform: "translate(-105.226 -294.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35319",
    "data-name": "Path 35319",
    d: "M197.36,296.215a.891.891,0,0,1,.9-.871.871.871,0,0,1,.843.871v7.154h3.884a.942.942,0,1,1,0,1.87h-4.725a.862.862,0,0,1-.9-.87v-8.154Z",
    transform: "translate(-187.077 -294.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35320",
    "data-name": "Path 35320",
    d: "M270.712,294c.329-2.771,4.511-3.27,6.482-1.755a.836.836,0,1,1-.914,1.4c-1.057-.67-3.455-.984-3.755.5-.386,2.343,5.825,1,5.725,4.8-.1,3.627-5.354,3.711-7.325,2.084a1.055,1.055,0,0,1-.2-1.4.843.843,0,0,1,1.271-.1c1.17.8,4.184,1.4,4.4-.63C276.209,296.789,270.269,298.059,270.712,294Z",
    transform: "translate(-252.096 -291.407)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35321",
    "data-name": "Path 35321",
    d: "M129.929,417.786H96v1.786h33.929a1.791,1.791,0,0,0,1.786-1.786V416A1.791,1.791,0,0,1,129.929,417.786Z",
    transform: "translate(-56.857 -369.571)",
    fill: "#cad1d8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/XLS.f1d0b069c21d996695b6af1abf14ef0c.svg";
export { ForwardRef as ReactComponent };